type Props = {
  text: string;
};

function LiveDescription({ text }: Props) {
  return <div>{text}</div>;
}

export default LiveDescription;
